import React from 'react'
import PropTypes from 'prop-types'
import {
  VimePlayer,
  VimeAudio,
  VimeDefaultUi,
  VimePlaybackControl,
  VimeControls,
} from '@vime/react'
import TruncateMarkup from 'react-truncate-markup'

import '@vime/core/themes/default.css'
import '@vime/core/themes/light.css'

import { isAudio } from '../utils'
import EpisodeMeta from './EpisodeMeta'

const ListEpisode = ({ title, summary, link, enclosures, meta }) => {
  const mediaPlayer = enclosures.filter(isAudio).map((media) => (
    <VimePlayer theme='light' data-testid='episode' key={media.url}>
      <VimeAudio>
        <source src={media.url} type={media.type} />
      </VimeAudio>
      <VimeDefaultUi noControls>
        <VimeControls>
          <VimePlaybackControl
            hideTooltip
            style={{ '--vm-control-scale': 0.8 }}
          />
        </VimeControls>
      </VimeDefaultUi>
    </VimePlayer>
  ))

  return (
    <div className='card'>
      <div className='row g-0 flex-nowrap align-items-start'>
        <div className='col'>
          <div className='card-body'>
            <header className='mb-2 position-relative'>
              <div className='h5 card-title mb-1'>
                {/*
                    NOTE: titles from rss feed contain encoded HTML-Entities
                    which only render correctly when we _dangerously_ set the
                    raw HTML as content of the link.
                  */}
                <a href={link.url} className='text-dark text-decoration-none stretched-link'
                   dangerouslySetInnerHTML={{__html: title}} />
              </div>
              <TruncateMarkup lines={2} tokenize='words'>
                <p className='mb-0'>{summary}</p>
              </TruncateMarkup>
            </header>
            <div className='row g-2 align-items-start justify-content-between small mb-0'>
              <div className='col-auto'>
                <div className=''>{mediaPlayer}</div>
              </div>
              <div className='col text-body-secondary'>
                <EpisodeMeta {...meta} />
              </div>
            </div>
          </div>
        </div>
        <div className='col-auto h-100'>
          <div className='card-body h-100 position-relative'>
            <a href={link.url} className='text-dark stretched-link'>
              <i className='bi bi-arrow-right-circle fs-4 float-end flex-shrink-0' />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

ListEpisode.propTypes = {
  title: PropTypes.string.isRequired,
  meta: PropTypes.exact({
    duration: PropTypes.string,
    published: PropTypes.string,
    authors: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  summary: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
  enclosures: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ListEpisode
